var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnrichCompaniesIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 4.417V.75H.835v16.5h18.333V4.417zm-5.5 11H2.668v-1.834h1.834zm0-3.667H2.668V9.917h1.834zm0-3.667H2.668V6.25h1.834zm0-3.666H2.668V2.583h1.834zm3.667 11H6.334v-1.834h1.833zm0-3.667H6.334V9.917h1.833zm0-3.667H6.334V6.25h1.833zm0-3.666H6.334V2.583h1.833zm9.167 11h-7.333v-1.834h1.833V11.75h-1.833V9.917h1.833V8.083h-1.833V6.25h7.333zm-1.833-7.334h-1.834v1.834h1.834zm0 3.667h-1.834v1.833h1.834z"
})));
export default SvgEnrichCompaniesIcon;